export default __webpack_public_path__ + "static/media/Maurizio Maggiani e Michele De Mieri.5bc65208.jpg";